import {useEffect, useRef, useState} from 'react';

type UseLoadingParams = {
	isLoading?: boolean;
	onLoading?: () => void;
	onLoaded?: () => void;
};

export const useLoading = ({
	isLoading,
	onLoading,
	onLoaded,
}: UseLoadingParams = {}) => {
	const [loading, setLoading] = useState(isLoading);
	const loadingRef = useRef(loading);

	useEffect(() => {
		setLoading(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (loadingRef.current === loading) return;
		loadingRef.current = loading;
		loading ? onLoading?.() : onLoaded?.();
	});

	return {
		loading,
		setLoading,
	};
};

export default useLoading;
